// src/pages/BudgetCoach.jsx
import React from "react";
import BudgetCoach from "../components/BudgetCoach";

export default function BudgetCoachPage() {
  return (
    <div className="pt-2 lg:pt-4 pb-16">
      <BudgetCoach />
    </div>
  );
}
